import React from "react";
import Grievance from "./Grievance";
import GrievanceOfficerPage from "./GrievanceOfficerPage";
const GrievanceSection = () => {
  return (
    <div className="container mx-auto px-4 py-12">
      <Grievance />
      <GrievanceOfficerPage />
    </div>
  );
};
export default GrievanceSection;
